package com.xtream.ui.tv.presentation.tvchannels

import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.paging.compose.collectAsLazyPagingItems
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.ui.platform.adaptiveValue
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.live_tv
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.ui.tv.presentation.common.ContentGridTvScreen
import com.xtream.ui.ui.widget.NetworkImageCard
import com.xtream.ui.ui.widget.Visibility
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalStdlibApi::class)
@Composable
fun LiveTvGridTvScreen(
    modifier: Modifier=  Modifier,

    id: Int? = null,
    title: String? = null,
    query: String? = null,

    streamControlViewModel: StreamControlViewModel = koinViewModel(),
    carousel: @Composable (() -> Unit)? = null,
    navKey: Screen.LiveTvGrid,
){
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner
    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )
    val scrollState = rememberLazyGridState()

    LaunchedEffect( query) {
        streamControlViewModel.searchByCategoryFlow.value = id
        streamControlViewModel.search( query)

        delay(100)
        //scrollState.scrollToItem(0)
    }

    val pagedStreamsFlow= remember(streamControlViewModel) { streamControlViewModel.liveStreamsFilteredPagingFlow }
    val homeScreenPagedItems
            =pagedStreamsFlow.collectAsLazyPagingItems()


    val columnsNum= adaptiveValue(expandedValue = 7, compactValue = 3, default = 3)
    val listScrollState = rememberSaveable(saver = LazyGridState.Saver) {
        LazyGridState()
    }
    ContentGridTvScreen(
        scrollState = listScrollState,
        modifier = modifier,
        numColumns = columnsNum,
        title  = {
            Text(
                stringResource(Res.string.live_tv),
                style = MaterialTheme.typography.headlineMedium
            )
        },
        subtitle  = title?.takeIf { it.isNotEmpty() }?.let { {
            Text(title, style = MaterialTheme.typography.titleMedium)}},

        /* actions = {
             IconButton(
                 onClick = { *//* Favorite action *//* },
                modifier = Modifier
                    .size(48.dp)
                    .background(Color.Transparent, CircleShape),
                colors = IconButtonDefaults.iconButtonColors(
                    contentColor = Color.White
                )
            ) {
                Icon(
                    imageVector = Icons.AutoMirrored.Filled.Sort,
                    contentDescription = stringResource( R.string.filter),
                )
            }
        },*/

        carousel = carousel,
        lazyPagingItems = homeScreenPagedItems,

        ){

        (it as? LiveStream?)?.let { stream->
            NetworkImageCard(
                src=stream.streamIcon,
                useAutoAlpha = true,
                /*  title = stream.name?:"",
                  description = stream.formattedRating()?:"",*/
                //dependOnWidth = false,
                infoSectionVisibility= Visibility.HIDE,
                aspectRatio = 1f,
                width = (-1).dp,// to fill width
                onClick = {
                    rootNavViewModel.navigate(
                        Screen.LiveStreamPlayer(
                            stream.streamId,
                            stream.categoryId,
                            stream.name
                        )
                    )

                }
            )
        }

    }


}
